import React from 'react'

export default function VisiGiftCreateCampaign() {
  return (
    <div>VisiGiftCreateCampaign</div>
  )
}
